export {
	challengesAboveList,
	forBusiness_furniture_challenges,
} from './challengesData';
export { forBusiness_furniture_crafted } from './craftedData';
export { forBusiness_furniture_elevate } from './elevateData';
export { forBusiness_furniture_use } from './useData';
export { forBusiness_furniture_tips } from './tipsData';
export { forBusiness_furniture_perfect } from './perfectForData';
